import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { bindActionCreators } from "redux";
import { connect } from "react-redux"; 
import { withRouter, Link } from 'react-router-dom'

import Preloader from "../components/Preloader";
import PageWrapper from "../components/PageWrapper";

import { pageTitle } from "../helpers/pageTitle";
import { getRoute, apiRequest } from "../helpers/Api";
import { doAuthCheck } from "../actions/Auth";
import { RequireCapability } from "./RequireCapability";

import DamOperationsTable from "../components/dam-ops/DamOperationsTable";

import { 
    togglePreloader,
    showFetchError
} from "../actions/index";


function getInitialState(){
    return {
        fetchingDamOperationLogs: false,
        fetchingStation: false,
        operationLogs: null,
        stationDetails: null,
        morePages: false,
        curPage: 1,
        errorMessage: null
    }
}

class DamOperationLogContainer extends Component {
    constructor ( props ) {
        super(props);

        this.getDamOperationLogData = this.getDamOperationLogData.bind(this);
        this.getStationData = this.getStationData.bind(this);

        this.state = getInitialState();
    }

    componentDidMount(){
        window.scrollTo(0,0);
        this.getStationData();
        this.getDamOperationLogData();
    }

    componentDidUpdate(prevProps, prevState){

        let wasPreviousLoading = false;
        let currentlyLoading = false;

        // check if previously was in a loading state
        if( prevState.fetchingDamOperationLogs === true ||
            prevState.fetchingStation === true ){
            wasPreviousLoading = true;
        }

        // check if currently in a loading state
        if( this.state.fetchingDamOperationLogs === true ||
            this.state.fetchingStation === true ){
            currentlyLoading = true;
        }

        if( currentlyLoading === false && wasPreviousLoading === true ){
            //transitioning from loading
            this.props.togglePreloader(false);
        }
        else if ( currentlyLoading === true && wasPreviousLoading === false ){
            //transitioning to loading
            this.props.togglePreloader(true);
        }

        // when the current page is changed fetch the additional items
        if(prevState.curPage !== this.state.curPage ){
            this.getDamOperationLogData();
        }
    }

    addOperationListTogether(currentArray, newArray){

        // we are starting with a new set 
        if(currentArray === null){
            currentArray = [];
        }

        // combine the two arrays without mutating their objects
        const newState = [];

        for (let i = 0; i < currentArray.length; i++) {
            newState.push({...currentArray[i]});
        }

        for (let i = 0; i < newArray.length; i++) {
            newState.push({...newArray[i]});
        }

        return newState;
    }


    getStationData(){

        this.setState({
            fetchingStation: true,
        })
        apiRequest( getRoute("stationDetails", this.props.match.params.stationSlug) )
            .then(result => {
                this.setState({
                    fetchingStation: false,
                    stationDetails: result
                });
            })
            .catch( (error) => {
                // on error restting to the initial state and showing the loading message
                const netState = getInitialState();
                netState.errorMessage = true;
                this.setState(netState);
            })

    }


    getDamOperationLogData() {
        this.setState({
            fetchingDamOperationLogs: true,
        });

        const fetchArgs = {
            station_slug: this.props.match.params.stationSlug,
            page: this.state.curPage
        }

        apiRequest( getRoute("damOpsLogs", [], fetchArgs) )
            .then(result => {
                
                this.setState({
                    fetchingDamOperationLogs: false,
                    operationLogs: this.addOperationListTogether(this.state.operationLogs, result.results),
                    morePages: ( result.next === null ? false : true )
                });
            })
            .catch( (error) => {
                // on error restting to the initial state and showing the loading message
                const netState = getInitialState();
                netState.errorMessage = true;
                this.setState(netState);

            })
    }



	render() {

        let title = "Loading Dam Operation Logs";
        let headingTitle = title;
        let content = null;

        if( this.state.errorMessage !== null ){
            // content for when in an error state
            title = "Error loading dam operation logs"
            content = (
                <div>
                    <h2>Error</h2>
                    <p>An error occured while loading the dam operation logs.</p>
                </div>
            )
        }
        else if( this.state.fetchingStation && this.state.fetchingDamOperationLogs ){
            // content for when on initiail load
            content = (
                <h2>{title}</h2>
            )
        }
        else{
            // content for when we have dam safety codes
            const opLogs = [];
            let headingTitle = title;

            // if we have a station set the title
            if( this.state.stationDetails !== null ){
                title = this.state.stationDetails.station_name + "Dam Operation Logs";
                headingTitle = this.state.stationDetails.station_name;
            }

            if( this.state.operationLogs !== null ){


                opLogs.push(
                    <div className="dam-operation-logs">
                        <DamOperationsTable logs={this.state.operationLogs} />
                    </div>
                )
                
            

            }
            else{
                // we are in a loading state
                opLogs.push(<span key="loading-log">Loading Logs</span>);
            }


            let nextPageButton = null;
            if( this.state.morePages && !this.state.fetchingDamOperationLogs ){
                nextPageButton = (
                    <div className="dam-ops-load-more">
                        <button className="dam-ops-load-more" onClick={ () => this.setState({'curPage': this.state.curPage + 1})}>Load More</button>
                    </div>
                );
            }

    		content = (
                    <div className="container-fluid" role="region" aria-labelledby="station-region">
                        <h2 id="station-region" className="dam-ops-title-with-back">{ headingTitle }</h2>
                        <Link to={`/dam-ops/`}>Back to Dam Ops</Link>
                        <div className="dam-safety-code-logs">
                            <span>Dam operation logs: </span>
                            {opLogs}
                        </div>
                        {nextPageButton}
                    </div>
    		)


        }

        return (
            <PageWrapper fullWidth={true} >
                <Helmet>
                    <title>{ pageTitle(title) }</title>
                </Helmet>
                <Preloader showPreloader={ this.props.handleTogglePreloader } message="Fetching Dam Operation Logs" />
                {content}
            </PageWrapper>
        )

    }
}


function mapStateToProps(state) {
    return { 
        handleTogglePreloader: state.togglePreloader,
        fetchErrorMsg: state.fetchErrorMsg,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({ 
        togglePreloader: togglePreloader,
        showFetchError: showFetchError,
        doAuthCheck: doAuthCheck
    }, dispatch)    
}

export default RequireCapability( 
    withRouter( 
        connect( mapStateToProps, matchDispatchToProps )( DamOperationLogContainer ) 
    ), 
    'canAccessDamOperationsLog' 
); 